import { css } from 'styled-components'

export const container = css`
  flex: 1;
`
export const inputContainerStyles = css`
  padding: 16px 16px 24px 16px;
  border-top: 0.1em solid ${({ theme }) => theme.colors.inputBorder}; ;
`
